import React, { useState } from "react";
import Layout from "../../components/layouts/layout";
import "./style.scss";
import LPFooter from "../../components/LPFooter";
import Image1 from "../../assets/Images/web-submit/service-1.png";
import Image2 from "../../assets/Images/web-submit/service-2.png";
import Image3 from "../../assets/Images/web-submit/service-3.png";
import WebSummit from "../../assets/Images/web-submit/web.png";
import BaskarImage from "../../assets/Images/newAboutUs/baskar.png";
import RameshImage from "../../assets/Images/newAboutUs/ramesh.png";
import MourinaImage from "../../assets/Images/web-submit/mourina.png";
import DataService from "../../services/api/data_services";
import { navigate } from "gatsby";
import OGImage from '../../assets/Images/web-submit/OGImage_websummit.png'

function WebSummitLanding() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    company: "",
    lookingFor: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    DataService.postData(
      `admin/api/sendmail`,
      {
        firstName: formData.fullName.split(' ')[0] || '',
        lastName: formData.fullName.split(' ').slice(1).join(' ') || '',
        email: formData.email,
        organization: formData.company,
        selectedType: formData.lookingFor,
        message: formData.message,
        pageUrl: "/digiryte-at-web-summit-lisbon-2025",
      },
      {
        type: "contactus_new",
      }
    )
      .then((response) => {
        if (typeof window !== `undefined`) {
          navigate(`/thank-you-contact`);
        }
      })
      .catch((error) => {
        console.error("Form submission error:", error);
        alert("There was an error submitting the form. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector("#form-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const services = [
    {
      key: "01",
      icon: "⚙️",
      title: "Service for Equity",
      highlight: "without burning cash",
      description:
        "Turn your vision into reality - without burning cash. We build your MVP, product, or digital platform in exchange for equity.",
      subHighlight:
        "Ideal for early-stage startups looking for technical co-founders or delivery partners.",
      imageUrl: Image1,
    },
    {
      key: "02",
      icon: "💸",
      title: "Pre-Seed & Seed Investment",
      highlight: "across UK, EU, and globe",
      description:
        "We invest in high-potential startups through our venture network across the UK, EU, and the globe.",
      highlights: [
        "Backed by digiRyte founders, partner funds, and strategic angels",
        "Focus on AI, HealthTech, SaaS, FinTech, and Climate Tech",
      ],
      imageUrl: Image2,
    },
    {
      key: "03",
      icon: "🌍",
      title: "Global Capability Centers",
      highlight: "your team, your culture",
      description:
        "digiRyte builds and manages your dedicated global team - tailored to your goals, functions, and culture. You stay in control. We handle everything else.",
      highlights: [
        "Access world-class talent across tech, marketing, customer success, operations, and more",
        "Transparent cost-plus model - you pay operating cost + 20% management margin",
        "Embedded governance, HR, and compliance - zero hassle",
        "Scale in weeks, not months",
        "Your team, your culture - powered by digiRyte's expertise",
      ],
      imageUrl: Image3,
    },
  ];

  const teamMembers = [
    {
      name: "Dr Baskar Raju",
      role: "CEO & MD",
      shortInfo: "Surgeon-Turned Tech CEO | Angel Investor | Ex-NHS Digital Innovation Lead",
      image: BaskarImage,
      link: "https://calendly.com/baskar-digiryte/30min",
    },
    {
      name: "Ramesh Raja",
      role: "Field CTO",
      shortInfo: "Go-to Advisor for Growth-Tech Execution | Startup-to-Scale Digital Architecture",
      image: RameshImage,
      link: "https://calendly.com/ramesh-raja/30minutes",
    },
    {
      name: "Mourina",
      role: "Associate Director - Venture Deals and AI Strategy",
      shortInfo: "Venture Partnerships & AI Strategy",
      image: MourinaImage,
      link: "https://calendly.com/mourina-digiryte/30min",
    },
  ];

  return (
    <Layout
      seo={{
        title: "digiRyte - The Big4-Lite Tech Consultant | Web Summit Lisbon 2025",
        ogtitle:
          "digiRyte - The Big4-Lite Tech Consultant | Web Summit Lisbon 2025",
        description:
          "Where tech, capital, and strategy meet to scale tomorrow's ventures. Meet digiRyte at Web Summit Lisbon.",
        keywords:
          "Web Summit Lisbon 2025, startup investment, service for equity, global capability centers, venture capital, MVP development, pre-seed funding",
        ogimage: OGImage,
      }}
      isLandingPage={true}
      pageUrl={"/digiryte-at-web-summit-lisbon-2025"}
      redirectContactTo={"/digiryte-at-web-summit-lisbon-2025#form-section"}
      handleClick={scrollToContact}
    >
      {/* Hero Section */}
      <div className="ticket-hero">
        <div className="background-overlay"></div>
        <div className="hero-content">
          <p className="badge-hero">Web Summit Lisbon 2025</p>
          <h1>
            <span className="hero-title-line-1">We're at Web Summit Lisbon</span>
            <span className="hero-title-line-2">Powering Startups Beyond Code</span>
          </h1>
          <p className="description">
            Meet <b>digiRyte</b> - where technology, capital, and strategy meet to
            scale tomorrow's ventures.
            <br />
            Join us at Web Summit Lisbon to explore how we invest, build, and
            partner for growth.
          </p>
          <div className="cta-buttons">
            <button className="download-btn" onClick={scrollToContact}>
              Meet Us at Web Summit →
            </button>
            <a 
              href="https://calendly.com/mourina-digiryte/30min" 
              target="_blank" 
              rel="noopener noreferrer"
              className="learn-btn"
            >
              Book a Call
            </a>
          </div>
        </div>
      </div>

      {/* Who We Are Section */}
      <section className="features-section">
        <div className="body-container">
          <div className="badge">Who We Are</div>
          <h1 className="headline">
            digiRyte | <span className="highlight">Big4 Lite</span> Tech
            Consultants
          </h1>
          <p style={{ textAlign: "center", fontSize: "1.125rem", color: "#666", maxWidth: "800px", margin: "0 auto 4rem" }}>
            We help visionary founders bridge the gap between tech and traction
            - through capital, product strategy, and execution. From pre-seed to
            growth, we back founders who are building world-changing products.
          </p>

          {/* What We Do - Features */}
          <div className="content-wrapper">
            {services.map((service) => (
              <div className="feature-item" key={service.key}>
                <div className="phone-mockup">
                  <div className="phone-screen">
                    <img
                      src={service.imageUrl}
                      alt={`${service.title}`}
                    />
                  </div>
                </div>
                <div className="feature-text">
                  <div className="counter-title">/ {service.key}</div>
                  <h2>
                    <span className="highlight-blue">{service.title}</span>{" "}
                    {service.highlight}
                  </h2>
                  <p>{service.description}</p>
                  {service.subHighlight && (
                    <p style={{ color: "#db4435", fontWeight: "600", marginTop: "1rem" }}>
                      ✅ {service.subHighlight}
                    </p>
                  )}
                  {service.highlights && (
                    <ul style={{ listStyle: "none", padding: 0, marginTop: "1rem" }}>
                      {service.highlights.map((item, idx) => (
                        <li key={idx} style={{ color: "#666", marginBottom: "0.5rem", fontSize: "0.95rem" }}>
                          ✅ {item}
                        </li>
                      ))}
                    </ul>
                  )}
                  <button className="learn-more" onClick={scrollToContact}>Connect with Us</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet the Team Section */}
      <section className="updates-section">
        <div className="body-container">
          <div className="content-wrapper">
            <div className="updates-content">
              <h1>
                Meet Us at
                <br />
                <span className="highlight">Web Summit Lisbon</span>
              </h1>
              <p>
                We're coming to Web Summit Lisbon 2025 to meet founders,
                <br />
                investors, and partners who are shaping the future.
                <br />
                If you're looking for strategic investment, service-for-equity
                <br />
                collaboration, or GCC market access, let's connect.
              </p>
              <button className="download-btn" onClick={scrollToContact}>
                Book a Call
              </button>
            </div>

            <div className="phone-ui">
              <div className="phone-screen">
                <img
                  src={WebSummit}
                  alt="Web Summit Event"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="active-users-section">
        <div className="body-container">
          <div className="section-badge">Our Team</div>

          <h1 className="section-title">
            Book a Call With Our Team
          </h1>

          <div className="team-members-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-member-card">
                <div className="team-member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-member-info">
                  <h3>{member.name}</h3>
                  <p className="team-member-role">{member.role}</p>
                  {member.shortInfo && (
                    <p className="team-member-short-info">{member.shortInfo}</p>
                  )}
                  <a 
                    href={member.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="contact-team-btn"
                  >
                    Book a Call
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="testimonials-section" id="form-section">
        <div className="body-container">
          <div className="testimonials-badge">Get in Touch</div>

          <h1 className="headline">
            Let's Connect at <span className="highlight">Web Summit</span>
          </h1>

          <div style={{ maxWidth: "700px", margin: "0 auto" }}>
            <form 
              style={{
                background: "white",
                padding: "3rem",
                borderRadius: "24px",
                boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)"
              }}
              onSubmit={handleSubmit}
            >
              <p style={{ textAlign: "center", marginBottom: "2rem", color: "#666" }}>
                Leave your details and we'll get back to you before the event.
              </p>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{ display: "block", fontWeight: "600", marginBottom: "0.5rem", color: "#1a1a1a" }}>
                  Full Name *
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your full name"
                  style={{
                    width: "100%",
                    padding: "1rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif"
                  }}
                />
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{ display: "block", fontWeight: "600", marginBottom: "0.5rem", color: "#1a1a1a" }}>
                  Email / LinkedIn *
                </label>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="your@email.com or LinkedIn URL"
                  style={{
                    width: "100%",
                    padding: "1rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif"
                  }}
                />
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{ display: "block", fontWeight: "600", marginBottom: "0.5rem", color: "#1a1a1a" }}>
                  Company / Startup Name *
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  required
                  placeholder="Your company name"
                  style={{
                    width: "100%",
                    padding: "1rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif"
                  }}
                />
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{ display: "block", fontWeight: "600", marginBottom: "0.5rem", color: "#1a1a1a" }}>
                  What You're Looking For *
                </label>
                <select
                  name="lookingFor"
                  value={formData.lookingFor}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: "100%",
                    padding: "1rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif",
                    cursor: "pointer"
                  }}
                >
                  <option value="">Select an option</option>
                  <option value="equity-service">Service for Equity</option>
                  <option value="investment">Investment</option>
                  <option value="gcc-access">GCC Access</option>
                  <option value="partnership">Partnership</option>
                </select>
              </div>

              <div style={{ marginBottom: "1.5rem" }}>
                <label style={{ display: "block", fontWeight: "600", marginBottom: "0.5rem", color: "#1a1a1a" }}>
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="4"
                  placeholder="Tell us about your project or what you'd like to discuss..."
                  style={{
                    width: "100%",
                    padding: "1rem",
                    border: "2px solid #e0e0e0",
                    borderRadius: "12px",
                    fontSize: "1rem",
                    fontFamily: "Inter, sans-serif",
                    resize: "vertical"
                  }}
                ></textarea>
              </div>

              <button 
                type="submit" 
                style={{
                  width: "100%",
                  background: "linear-gradient(135deg, #db4435 0%, #b33629 100%)",
                  color: "white",
                  border: "none",
                  padding: "1.25rem 2rem",
                  fontSize: "1.125rem",
                  fontWeight: "600",
                  borderRadius: "50px",
                  cursor: "pointer",
                  marginTop: "1rem"
                }}
              >
                👉 Connect with digiRyte
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer Quote Section */}
      <section className="music-quote-section">
        <div className="body-container">
          <div className="quote-content">
            <div className="decorative-circles">
              <div className="circle circle-1"></div>
              <div className="circle circle-2"></div>
              <div className="circle circle-3"></div>
            </div>
            <h1 className="quote-text">
              Technology +
              <br />
              Capital +
              <br />
              Strategy
            </h1>
            <p className="quote-author">digiRyte | Based in the UK | Building Globally</p>
            <p className="quote-author" style={{ marginTop: "1rem" }}>
              <a href="https://www.digiryte.com" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>
                www.digiryte.com
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <a 
        href="https://wa.me/447383890287?text=Hi, I'm interested in connecting at Web Summit Lisbon 2025"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <svg 
          viewBox="0 0 32 32" 
          xmlns="http://www.w3.org/2000/svg"
          className="whatsapp-icon"
        >
          <path fill="currentColor" d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.052-13.487 13.487-13.487s13.487 6.052 13.487 13.487c0 7.435-6.052 13.487-13.487 13.487zM21.713 18.5c-0.297-0.149-1.757-0.868-2.030-0.967-0.272-0.099-0.47-0.149-0.669 0.148s-0.769 0.967-0.943 1.165c-0.173 0.198-0.347 0.223-0.644 0.074-0.297-0.149-1.255-0.462-2.39-1.475-0.883-0.788-1.48-1.761-1.653-2.059s-0.018-0.458 0.13-0.606c0.134-0.133 0.297-0.347 0.446-0.521s0.198-0.297 0.297-0.495c0.099-0.198 0.050-0.372-0.025-0.521s-0.669-1.611-0.916-2.206c-0.242-0.579-0.487-0.501-0.669-0.51-0.173-0.008-0.372-0.010-0.571-0.010s-0.52 0.074-0.793 0.372c-0.272 0.297-1.040 1.016-1.040 2.479s1.065 2.876 1.213 3.074c0.149 0.198 2.095 3.2 5.076 4.487 0.709 0.306 1.263 0.489 1.694 0.626 0.712 0.226 1.36 0.194 1.872 0.118 0.571-0.085 1.758-0.719 2.006-1.413s0.248-1.289 0.173-1.413c-0.074-0.124-0.272-0.198-0.57-0.347z"/>
        </svg>
      </a>

      <LPFooter ctaClick={scrollToContact} />
    </Layout>
  );
}

export default WebSummitLanding;
